import type {CategoryType, StatusType} from "../types";
import type {JSX} from "react";

export const getCategoryBadge = (category: CategoryType): JSX.Element => {
    const colors: Record<CategoryType, string> = {
        'Tour': 'bg-purple-500/20 text-purple-300 border-purple-500/30',
        'Catering': 'bg-sky-500/20 text-sky-300 border-sky-500/30',
        'Parcheggi': 'bg-amber-500/20 text-amber-300 border-amber-500/30',
        'Normale': 'bg-slate-500/20 text-slate-300 border-slate-500/30',
    };
    return <span className={`px-2.5 py-1 text-xs font-semibold rounded-full border ${colors[category] || colors['Normale']}`}>{category}</span>;
};

export const formatDateTime = (dateTimeString: string | null | undefined): string => {
    if (!dateTimeString) return 'N/A';
    try {
        const date = new Date(dateTimeString);
        const datePart = date.toLocaleDateString('it-IT');
        const timePart = date.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
        return `${datePart} ${timePart}`;
    } catch (e) {
        console.error("Errore nella formattazione della data:", e);
        return dateTimeString;
    }
};

// Formatta la data per una migliore leggibilità
export const formatDate = (dateString: string | null) => {
    if (!dateString) return 'Non specificato';
    try {
        const date = new Date(dateString);
        return date.toLocaleDateString('it-IT'); // Formato data italiano
    } catch (e) {
        return dateString; // In caso di errore, mostra la stringa originale
    }
};

export const getStatusBadge = (status: StatusType): JSX.Element => {
    const colors: Record<StatusType, string> = {
        'Attivo': 'bg-green-500/20 text-green-300',
        'Scaduto': 'bg-slate-600/30 text-slate-400',
        'In attesa': 'bg-yellow-500/20 text-yellow-300',
        'Approvato': 'bg-green-500/20 text-green-300',
    };
    const icons: Record<StatusType, JSX.Element> = {
        'Attivo': <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-1.5"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>,
        'Scaduto': <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-1.5"><circle cx="12" cy="12" r="10"/><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>,
        'In attesa': <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-1.5"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>,
        'Approvato': <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-1.5"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><polyline points="16 11 18 13 22 9"/></svg>,
    };
    return <span className={`inline-flex items-center px-2.5 py-1 text-xs font-semibold rounded-full ${colors[status]}`}>{icons[status] || ''}{status}</span>;
};
